import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const Tasks = withLazyFallback(() => import('components/admin/pages/Tasks/Tasks'));

const ADMIN_TASKS = [
  {
    path: 'tasks',
    element: <Tasks />,
    handle: { title: 'Tasks' }
  }
];

export default ADMIN_TASKS;
